import { useCallback, useState } from 'react';
import { tryParse } from '@utils/formatter';
const info = console.log;

/**
 * Create a persisted state in window.localStorage
 * @param localStorageKey
 * @param initialValue
 */
function usePersistedState<T>(localStorageKey: string, initialValue: T): [T, (arg: T) => void] {
  const [state, setState] = useState<T>(() => {
    try {
      if (typeof window !== 'undefined') {
        const storedState = localStorage.getItem(localStorageKey);
        if (storedState) return tryParse(storedState);
        else {
          localStorage.setItem(localStorageKey, JSON.stringify(initialValue));
          return initialValue;
        }
      }
      return initialValue;
    } catch (err) {
      info(err);
      return initialValue;
    }
  });

  const setPersistedState = useCallback(
    (newState: T) => {
      try {
        setState(newState);
        localStorage.setItem(localStorageKey, JSON.stringify(newState));
      } catch (err) {
        info(err);
      }
    },
    [localStorageKey, setState],
  );

  return [state, setPersistedState];
}

export default usePersistedState;
